<template>
  <div class="show-list-div">
    <div class="show-list">
      <ShowNewsContent
        v-show="limitNum > 0"
        :showListData="showList"
        @onNewsItemClick="onNewsItemClick"
      />
      <AppNoData v-show="limitNum === 0" />
    </div>
    <ShowPage
      :showTotal="limitNum"
      :showPageSize="20"
      @onPagechange="onPagechange"
    />
  </div>
</template>

<script>
import ShowNewsContent from "@/components/ShowNewsContent.vue";
import ShowPage from "@/components/ShowPage.vue";
import AppNoData from "@/components/AppNoData.vue";

export default {
  name: 'KnowConsult',
  components: {
    ShowNewsContent,
    ShowPage,
    AppNoData,
  },
  props: {
    showData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    showData() {
      this.afterIndexChange();
    },
  },
  data() {
    return {
      showNewsList: [],
      showList: [],
      limitNum: 0,
      page: 1,
    };
  },
  created() {},
  mounted() {
    this.afterIndexChange();
  },
  methods: {
    afterIndexChange() {
      if (this.showData.chooseIndex === this.showData.defaultIndex) {
        if (this.showList.length === 0) {
          this.getArticleList(this.showData.id, false);
        }
      }
    },
    // 资讯列表
    async getArticleList(catalogId, isAdd) {
      if (!isAdd) {
        this.page = 1;
      }
      const { code, data } = await this.$http.get_article_list({
        catalogId: catalogId,
        limit: 20,
        page: this.page,
        sortRuleType: 2,
      });
      if (code === 0) {
        this.limitNum = data.total;
        let backDataList = [];
        data &&
          data.records &&
          data.records.forEach((item) => {
            backDataList.push({
              name: item.title,
              time: item.createdTime,
              id: item.id,
            });
          });
        this.showList = isAdd
          ? [...this.showList, ...backDataList]
          : [...backDataList];
      }
    },
    onPagechange(changePage) {
      this.page = changePage;
      this.getArticleList(this.showData.id, true);
    },
    onNewsItemClick(item) {
      this.$emit("onNewsClick", {
        type: "newsClick",
        data: item,
        catalogId: this.showData.id,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.show-list {
  width: 100%;
  padding-bottom: 40px;
  min-height: 600px;
}
.show-list-div {
  width: 100%;
  background: #fff;
}
</style>
